import bridge from './index';

// @ts-ignore
window.vkBridge = window.vkConnect = bridge;
